module.exports = __webpack_public_path__ + "img/avatar1.3d8f3ee9.png";